"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireWildcard(require("react"));

var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));

var _m = _interopRequireDefault(require("../styles/m-43.css"));

var _textBlock = _interopRequireDefault(require("./text-block"));

var _imageBlock = _interopRequireDefault(require("./image-block"));

var _videoBlock = _interopRequireDefault(require("./video-block"));

var _m2 = _interopRequireDefault(require("./m-43.props/m-43.defaultProps"));

var _m3 = _interopRequireDefault(require("./m-43.props/m-43.propTypes"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * ## M43 - component
 *
 * Some really cool piece of description goes here.
 */
// We use the same default props for data and defaultData
// This keeps our PropTypes and DefaultProps objects nice and clean and non repeating
var dataUtils = new _mmcDataUtilities["default"]();
var shouldUseDataOrDefaultProps = dataUtils.shouldUseDataOrDefaultProps,
    renderEmptyString = dataUtils.renderEmptyString;

var M43 = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(M43, _React$Component);

  function M43() {
    return _React$Component.apply(this, arguments) || this;
  }

  // All components need a resourceType in order for AEM to be aware of its existance
  M43.resourceType = function resourceType() {
    return 'MFourThree_1_0_0';
  };

  var _proto = M43.prototype;

  _proto.getLayout = function getLayout(data, theme, youtubeVideoId) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      "data-imageBlockPosition": data.textBlockPosition === 'left' ? 'right' : 'left',
      className: theme['col-xs-12'] + " " + theme['col-md-6'] + " " + theme['col-md-offset-1'] + " " + _m["default"].imageContainer
    }, youtubeVideoId ? /*#__PURE__*/_react["default"].createElement(_videoBlock["default"], {
      data: data,
      theme: theme
    }) : /*#__PURE__*/_react["default"].createElement(_imageBlock["default"], {
      data: data,
      theme: theme
    })), /*#__PURE__*/_react["default"].createElement("div", {
      "data-textBlockPosition": data.textBlockPosition,
      className: theme['col-xs-12'] + " " + theme['col-md-4'] + " " + _m["default"].textContainer
    }, /*#__PURE__*/_react["default"].createElement(_textBlock["default"], {
      data: data,
      theme: theme
    })));
  };

  _proto.render = function render() {
    var _this$props = this.props,
        data = _this$props.data,
        theme = _this$props.theme,
        defaultData = _this$props.defaultData; // first we select the data from the larger query coming through

    var componentData = shouldUseDataOrDefaultProps(data, defaultData);
    var youtubeVideoId = componentData.video.youtubeVideoId;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['container-fluid'] + " " + (renderEmptyString(componentData.textBlockPosition) !== ' ' ? _m["default"][componentData.textBlockPosition] : ' ') + " " + _m["default"].contentContainer,
      automation: "automationValue"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _m["default"].contentWrapper + " " + theme.row
    }, this.getLayout(componentData, theme, youtubeVideoId)));
  };

  return M43;
}(_react["default"].Component);

exports["default"] = M43;
M43.displayName = 'M43';
M43.defaultProps = {
  data: _m2["default"],
  defaultData: _m2["default"],
  theme: {}
};